var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto"},[_c('v-progress-circular',{attrs:{"color":!_vm.error ? 'primary' : 'error',"indeterminate":!_vm.error,"size":"200","width":"10"}},[(!_vm.error)?_c('strong',[_vm._v(_vm._s(_vm.paymentComplete ? _vm.$t('booking') : _vm.$t('payment_confirmation'))+"...")]):_c('strong',[_vm._v(_vm._s(_vm.$t('error')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }